import React, { useState } from 'react';
import '../../assets/styles/ClientShared.css';

const FAQ = () => {
  const faqs = [
    {
      question: "How do I submit content for my website?",
      answer: "You can submit content through the 'Web Content' and 'Upload' section in your dashboard. Each section provides guidelines and examples to help you provide the right text for your website.",
    },
    {
      question: "What kind of images should I upload?",
      answer: "We recommend uploading high-quality images such as your company logo, photos of your products or services, team pictures, or photos of your business location (if applicable). Visit the 'Upload' section to add your files.",
    },
    {
      question: "Can I make changes to my website after it's launched?",
      answer: "Yes, you can request updates or changes to your website even after it's launched. Small updates can be included in your post-support plan, or additional charges may apply for larger changes.",
    },
    {
      question: "How long does it take to complete my website?",
      answer: "The timeline for your project depends on the package you selected and the complexity of your requirements. You can monitor your progress in the 'Current Stage' section of your dashboard.",
    },
    {
      question: "What happens if I don't know what content to write?",
      answer: "Don't worry! We provide content examples and guidelines in the 'Web Content' section to help you craft compelling text for your site. If you need further assistance, feel free to contact us.",
    },
    {
      question: "How do I contact support for questions or issues?",
      answer: "You can reach out to us by email at nextlvlwebsites@gmail.com. We'll respond promptly to assist you with your questions or concerns.",
    },
    {
      question: "What is included in my website package?",
      answer: "Your package includes the features listed in the 'Project Overview' section. This can range from basic website pages to advanced features like e-commerce, booking systems, or custom functionality.",
    },
    {
      question: "How do I track the progress of my project?",
      answer: "You can track your project's progress in the 'Current Stage' section on your dashboard. This provides a breakdown of each phase and its completion status.",
    },
    {
      question: "What files do you need from me?",
      answer: "We need your logo, high-quality images of your business or products, and any additional materials you'd like to include. Visit the 'Upload' section for detailed file categories.",
    },
    {
      question: "Can I preview my website before launch?",
      answer: "Yes, you can preview your website in the 'Website Revision' section. This allows you to provide feedback before the site goes live.",
    },
    {
      question: "What kind of support do I get after my website launches?",
      answer: "You receive 1 month of free post-launch support, which includes minor updates and troubleshooting. If you need ongoing maintenance, we offer optional support plans.",
    },
    {
      question: "How do I request changes to my website?",
      answer: "Reach out to us via email to discuss the pricing for website updates. If you have an active support plan, minor to medium changes are included as part of the service.",
    },
    {
      question: "Will my website be mobile-friendly?",
      answer: "Yes! All websites we create are fully responsive, ensuring they look great and function well on all devices, including smartphones and tablets.",
    },
    {
      question: "How can I track my website's performance?",
      answer: "Your website is integrated with Firebase Analytics. You can track your website's traffic, user behavior, and performance through your analytics dashboard in the client portal.",
    },
    {
      question: "What happens if I need major updates in the future?",
      answer: "Major updates, such as redesigns or adding new features, will require a separate agreement. Contact us through the client portal to discuss your needs.",
    },
    {
      question: "Do you provide ongoing website maintenance?",
      answer: "Yes, we offer website maintenance plans to keep your site updated, secure, and running smoothly. This includes security updates, content changes, and performance optimizations.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="cp-page cp-page--narrow">
      <div className="cp-page-header">
        <p className="cp-eyebrow">Client Portal</p>
        <h1 className="cp-title">FAQ</h1>
        <p className="cp-subtitle">Common questions about your project and our process.</p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {faqs.map((faq, index) => (
          <div
            key={index}
            style={{ background: 'var(--surface-100)', border: '1px solid var(--border)', borderRadius: 'var(--radius-md)', overflow: 'hidden' }}
          >
            <button
              onClick={() => toggleFAQ(index)}
              style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 24px', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left' }}
            >
              <span style={{ fontFamily: 'var(--font-ui)', fontSize: '0.9375rem', fontWeight: 600, color: 'var(--text-primary)' }}>{faq.question}</span>
              <span style={{ fontFamily: 'var(--font-mono)', fontSize: '0.875rem', color: 'var(--text-tertiary)', flexShrink: 0, marginLeft: '16px' }}>{activeIndex === index ? '−' : '+'}</span>
            </button>
            {activeIndex === index && (
              <div style={{ padding: '0 24px 18px', fontFamily: 'var(--font-body)', fontSize: '0.9375rem', color: 'var(--text-secondary)', lineHeight: 1.7 }}>
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
